module.exports = __webpack_public_path__ + "static/media/income.df4567f0.svg";